<div class="receivables-import-row-list-container">
  <table mat-table [dataSource]="receivablesImportRowDataSource">

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef > TU
      <td mat-cell *matCellDef="let element">
          {{element.insuranceCompany.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="importer">
      <th mat-header-cell *matHeaderCellDef > Importer </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.import?.importer">
          <br>({{element.import?.importer?.name}})
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{element.company?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="policyNumber">
      <th mat-header-cell *matHeaderCellDef > Numer polisy </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/naleznosci/lista/szczegoly', element.uuid]">
          {{element.policyNumber ? element.policyNumber : 'Brak numeru'}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef> Kwota należności </th>
      <td mat-cell *matCellDef="let element">
        {{(element.amountDue !== null ? element.amountDue : 0) | number:'1.2-2'}} zł
      </td>
    </ng-container>


    <ng-container matColumnDef="delatationAt">
      <th mat-header-cell *matHeaderCellDef> Data wymagalności  </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        {{element.registrationPartner?.ofwcaFullName}}
      </td>
    </ng-container>


    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
        </button>
      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator  [pageSizeOptions]="[10, 20, 50]" ></mat-paginator>
</div>

